import {
  PRE_PROJECT_DATA_RECIEVED,
  RECIEVED_GET_CRITERIA_AND_BUDGET,
  RECIEVED_GET_RESOLUTION,
  RECIEVED_GET_PARTICIPANTS_LIST,
  SEND_PARTICIPANTS_LIST_RECIEVED_ONEND,
  PROJECT_GROUP_RECEIVED,
  CLEAR_PROJECT_GROUP_RESPONSE,
  RECIEVED_RESUME_DATA,
  RECIEVED_SCHEDULE_CALL,
  RECIEVED_VIDEO_RECORDING,
  RECIEVED_VIDEO_RECORDING_RESOURCE,
  RECIEVED_QUERY_VIDEO_RECORDING,
  RECIEVED_UPDATELAYOUT_VIDEO_RECORDING,
  RECIEVED_STOP_VIDEO_RECORDING,
  RECIEVED_VIDEO_USERLIST,
  GETUIDDETAILS_RECEIVED,
  RECIEVED_VIDEO_RECORDING_UPDATE,
  RECIEVED_RTC_TOKEN_BUILDER,
  RTM_TRANSCRIPT_DATA,
  SAVE_RTM_TRANSCRIPT_DATA,
  STORE_RTM_TRANSCRIPT_LOGS,
  GET_RTM_TRANSCRIPT_DATA,
  GET_CHAPTERIZATION_DATA,
  RECEIVED_CHAPTERIZATION_DATA,
  CLEAR_CHAPTERIZATION_DATA,
  UPDATE_RTM_TRANSCRIPT_DATA,
  UPDATE_GUEST_DATA,
  RECIEVED_ADD_SECTION,
  RECIEVED_DRAG_QUESTION,
  CLEAR_ADD_SECTION,
  CLEAR_DELETE_SECTION,
  RECIEVED_EDIT_SECTION,
  CLEAR_EDIT_SECTION,
  STORE_RTM_TRANSCRIPT_MESSAGE_LOGS,
  CLEAR_CRITERIS_AND_BUDGET_STATUS,
  UPDATE_SID_DATA,
  DELETE_SECTION_RECEIVED,
  RECIEVED_DRAG_SECTION,
  RECEIVED_DRAG_QUESTION_ACROSS_SECTIONS,
  DEASSIGN_SAMPLE_AND_BUDGET_RECEIVED,
  CLEAR_DEASSIGN_SAMPLE_AND_BUDGET_RESPONSE
} from '../../constants/projects/ProjectConstants';
import actions from '../../actions';

import ReactDOM from 'react-dom';
import { getParticipants } from '../../actions/project';
import { deleteSection } from '../../sagas/design/design';

const INITL_STATE = {
  preSetupData: [],
  resumeData: [],
  schedulecall: [],
  resource_Id: [],
  resource_Data: [],
  Sid: [],
  stop: [],
  updateLayout: [],
  criteriaAndBudget: null,
  criteriaAndBudgetQuestionList: [],
  dropDownQuestions: [],
  getResolution: null,
  getParticipant: null,
  SendParticipant: null,
  GetcriteriaAndBudgetScreener: [],
  questionTypes: [],
  project_ID: null,
  addProjectResponse: null,
  projectIdentity: null,
  updateRecording: null,
  rtcTokenBuilder: null,
  rtmTranscriptData: null,
  saveRtmTranscriptData: null,
  storeTranscriptLogs: null,
  getRtmTranscriptData: null,
  topicSectionData: null,
  chapterizationLoading: false,
  updateRtmTranscriptData: null,
  updateGuestData: null,
  addSection: null,
  deleteSec: null,
  editSection: null,
  dragQuestion: null,
  dragSection: null,
  dragQuestionAcrossSections: null,
  storeTranscriptMessageLogs: null,
  criteriaAndBudgetStatus: null,
  sidUpdate: null,
  lastUpdated: null,
  deassignSampleAndBudgetResponse: null
};

const ProjectReducer = (state = INITL_STATE, action) => {
  switch (action.type) {
    case PRE_PROJECT_DATA_RECIEVED:
      return {
        ...state,
        preSetupData: action.payload
      };

    case UPDATE_SID_DATA:
      return {
        ...state,
        sidUpdate: action.payload
      };

    case RECIEVED_GET_CRITERIA_AND_BUDGET:
      const criteriaAndBudgetQuestions = action.payload.Response.Getcriteria_and_budget_screener.map(item => item.questionName_array).flat();
      const dropDownQuestions = criteriaAndBudgetQuestions
        .filter(item => item.isRequired == 1 && (item.questionType_ID === 1 || item.questionType_ID === 2))
        .map(item => ({
          label: item.questionName,
          value: item.question_ID
        }))

      
      return {
        ...state,
        criteriaAndBudget: action.payload.Response,
        GetcriteriaAndBudgetScreener: action.payload.Response.Getcriteria_and_budget_screener,
        criteriaAndBudgetQuestionList: action.payload.Response.Getcriteria_and_budget_screener.map(item => item.questionName_array).flat(),
        questionTypes: action.payload.Response.questionType,
        project_ID: action.payload.project_ID,
        projectIdentity: action.payload.projectIdentity,
        criteriaAndBudgetStatus: action.payload.Status.StatusCode,
        dropDownQuestions: dropDownQuestions
      };
    case CLEAR_CRITERIS_AND_BUDGET_STATUS:
      return {
        ...state,
        criteriaAndBudgetStatus: 0
      };
    case RECIEVED_GET_RESOLUTION:
      return {
        ...state,
        getResolution: action.payload
      };

    case RECIEVED_GET_PARTICIPANTS_LIST:
      return {
        ...state,
        getParticipant: action.payload
      };
    case SEND_PARTICIPANTS_LIST_RECIEVED_ONEND:
      return {
        ...state,
        SendParticipant: action.payload
      };

    case PROJECT_GROUP_RECEIVED:
      return {
        ...state,
        addProjectResponse: action.data
      };

    case CLEAR_PROJECT_GROUP_RESPONSE:
      return {
        ...state,
        addProjectResponse: null
      };

    case RECIEVED_RESUME_DATA:
      return {
        ...state,
        resumeData: action.payload
      };

    case RECIEVED_SCHEDULE_CALL:
      return {
        ...state,
        schedulecall: action.payload
      };

    case RECIEVED_VIDEO_RECORDING:
      return {
        ...state,
        resource_Id: action.payload.resourceId
      };
    case RECIEVED_VIDEO_RECORDING_RESOURCE:
      return {
        ...state,
        resource_Data: action.payload
      };

    case RECIEVED_QUERY_VIDEO_RECORDING:
      return {
        ...state,
        updateLayout: action.payload
      };

    case RECIEVED_UPDATELAYOUT_VIDEO_RECORDING:
      return {
        ...state,
        Sid: action.payload
      };

    case RECIEVED_STOP_VIDEO_RECORDING:
      return {
        ...state,
        stop: action.payload
      };

    case RECIEVED_VIDEO_USERLIST:
      return {
        ...state,
        userList_Data: action.payload
      };

    case GETUIDDETAILS_RECEIVED:
      return {
        ...state,
        getUIDData: action.payload
      };

    case RECIEVED_VIDEO_RECORDING_UPDATE:
      return {
        ...state,
        updateRecording: action.payload
      };

    case RECIEVED_RTC_TOKEN_BUILDER:
      return {
        ...state,
        rtcTokenBuilder: action.payload
      };
    case RTM_TRANSCRIPT_DATA:
     
      return {
        ...state,
        rtmTranscriptData: action.payload,
        lastUpdated: Date.now()

      };
    case SAVE_RTM_TRANSCRIPT_DATA:
      return {
        ...state,
        saveRtmTranscriptData: action.payload
      };

    case STORE_RTM_TRANSCRIPT_LOGS:
      return {
        ...state,
        storeTranscriptLogs: action.payload
      };

    case GET_RTM_TRANSCRIPT_DATA:
      return {
        ...state,
        getRtmTranscriptData: action.payload
      };

    case GET_CHAPTERIZATION_DATA:
      return {
        ...state,
        topicSectionData: null,
        chapterizationLoading: true
      };

    case RECEIVED_CHAPTERIZATION_DATA:
      return {
        ...state,
        topicSectionData: action.payload,
        chapterizationLoading: false
      };

    case CLEAR_CHAPTERIZATION_DATA:
      return {
        ...state,
        topicSectionData: null,
        chapterizationLoading: false
      };

    case UPDATE_RTM_TRANSCRIPT_DATA:
      return {
        ...state,
        updateRtmTranscriptData: action.payload
      };

    case UPDATE_GUEST_DATA:
      return {
        ...state,
        updateGuestData: action.payload
      };

    case STORE_RTM_TRANSCRIPT_MESSAGE_LOGS:
      return {
        ...state,
        storeTranscriptMessageLogs: action.payload
      };

    case RECIEVED_ADD_SECTION:
      return {
        ...state,
        addSection: action.payload.data.Status
      };

    case DELETE_SECTION_RECEIVED:
      return {
        ...state,
        deleteSec: action.payload
      };

    case RECIEVED_DRAG_QUESTION:
      return {
        ...state,
        dragQuestion: action.payload.data.Status
      };

    case RECIEVED_DRAG_SECTION:
      return {
        ...state,
        dragSection: action.payload.data.Status,
        dragsECTION: action.payload.data.Status
      };

    case RECEIVED_DRAG_QUESTION_ACROSS_SECTIONS:
      return {
        ...state,
        dragQuestionAcrossSections: action.payload.data.Status
      };

    case CLEAR_ADD_SECTION:
      return {
        ...state,
        addSection: 0
      };

    case CLEAR_DELETE_SECTION:
      return {
        ...state,
        deleteSec: 0
      };

    case RECIEVED_EDIT_SECTION:
      return {
        ...state,
        editSection: action.payload.data.Status
      };

    case CLEAR_EDIT_SECTION:
      return {
        ...state,
        editSection: 0
      };

    case DEASSIGN_SAMPLE_AND_BUDGET_RECEIVED:
      return {
        ...state,
        deassignSampleAndBudgetResponse: action.payload
      };

    case CLEAR_DEASSIGN_SAMPLE_AND_BUDGET_RESPONSE:
      return {
        ...state,
        deassignSampleAndBudgetResponse: null
      };

    default:
      return state;
  }
};

export default ProjectReducer;
